import BaseTable from "../BaseTable";
import CountryModal from "@/Modals/RegionManagement/Countries/Modal";
import { FILTER_TYPE } from "@/constant/constants";
import { booleanOptionFilters } from "@/constant/GeneralOptions/boolean";
import { columns } from "./Columns";
import { countryManagementApi } from "@/apis/apis";
import { featureStatusFilters } from "@/constant/GeneralOptions/feature-status";

export default function CountriesPage() {
  const booleanOptionFiltersMap = booleanOptionFilters();
  const additionalFilters = [
    {
      id: "filter[tld_owned]",
      label: "TLD Owned",
      type: FILTER_TYPE.SELECT,
      options: booleanOptionFiltersMap,
    },
    {
      id: "filter[enable_professional_user]",
      label: "Commercial User",
      type: FILTER_TYPE.SELECT,
      options: featureStatusFilters,
    },
    {
      id: "filter[enable_personal_user]",
      label: "Personal User",
      type: FILTER_TYPE.SELECT,
      options: featureStatusFilters,
    },
  ];

  const confirmationModalTitleKey = (data) => {
    return `${data.region ? data.region + " - " : ""}${data.country.name}`;
  };

  return (
    <BaseTable
      label="Country"
      apiURL={countryManagementApi}
      columns={columns()}
      ModalComponent={CountryModal}
      importData={null}
      enableSortData={true}
      enableExport={false}
      confirmationModalTitleKey={confirmationModalTitleKey}
      enableStatus={false}
      additionalFilters={additionalFilters}
    />
  );
}
